module.exports = __webpack_public_path__ + "img/topmgmtchart.5ed053ad.jpg";